import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useEffect, useState } from "react";

// options is an array of { key: string, name: string, icon?: ReactComponent }
const MultiSelectWithAll = ({ options, onSelectionChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    onSelectionChange(selectedOptions);
  }, [selectedOptions, onSelectionChange]);

  const handleOptionChange = (optionKey) => {
    const updatedOptions = selectedOptions.includes(optionKey)
      ? selectedOptions.filter((item) => item !== optionKey)
      : [...selectedOptions, optionKey];

    setSelectedOptions(updatedOptions);
    if (updatedOptions.length === options.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedOptions([]);
      setSelectAll(false);
    } else {
      const allKeys = options.map((option) => option.key);
      setSelectedOptions(allKeys);
      setSelectAll(true);
    }
  };

  return (
    <>
      <FormControl component="fieldset">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectAll}
                onChange={handleSelectAllChange}
                name="selectAll"
              />
            }
            label="All"
          />
          {options.map((option) => (
            <FormControlLabel
              key={option.key}
              control={
                <Checkbox
                  checked={selectedOptions.includes(option.key)}
                  onChange={() => handleOptionChange(option.key)}
                  name={option.key}
                />
              }
              label={
                option.icon ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    {option.icon}
                    {option.name}
                  </Box>
                ) : (
                  option.name
                )
              }
            />
          ))}
        </FormGroup>
      </FormControl>
    </>
  );
};

export default MultiSelectWithAll;
